import { useLocale } from 'next-intl';

import LandingPageTestimonials from '@/app/components/LandingPage/LandingPageTestimonials';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

import { businessCaseStudiesOR4 } from './data/data';

const BusinessCaseStudy = () => {
  const locale = useLocale();
  const testimonials = businessCaseStudiesOR4(getLocalePartialUrl(locale));

  return (
    <section className="pb-20" data-cy="business-case-study">
      <LandingPageTestimonials
        testimonials={testimonials}
        theme="darkSandstone"
      />
    </section>
  );
};

export default BusinessCaseStudy;
